/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,
  
} from '@thd-olt-component-react/fusion-utils';


  import {
    RulesMiddleware as RulesMiddleware_MiddlewareSlot
  } from '@thd-olt-component-middleware/pip';



  import { withStorefront } from '@thd-olt-component-middleware/pip';




  
  import { BrowseSearchMetadata }
    from "@thd-olt-component-react/metadata";
  
  export { BrowseSearchMetadata };

  
  import { TrackOrder }
    from "@thd-olt-component-react/track-order";
  
  export { TrackOrder };

  
  import { Breadcrumbs }
    from "@thd-olt-component-react/breadcrumbs";
  
  export { Breadcrumbs };

  
  import { SponsoredBannerComposable }
    from "@thd-olt-component-react/sponsored-content";
  
  export { SponsoredBannerComposable };

  
  import { PLPResultsHeader }
    from "@thd-olt-component-react/product-results";
  
  export { PLPResultsHeader };

  
  import { PlpCategoryIntroduction }
    from "@thd-olt-component-react/emt-generated-content";
  
  export { PlpCategoryIntroduction };

  
  import { HybridContentfulWidgetComposable }
    from "@thd-olt-component-react/hybrid";
  
  export { HybridContentfulWidgetComposable };

  
  import { ProductCategoryVisnavComposable }
    from "@thd-olt-component-react/product-category-visnav";
  
  export { ProductCategoryVisnavComposable };

  
  import { PLPRecsComposable }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { PLPRecsComposable };

  
  import { ResultsAppliedComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsAppliedComposable };

  
  import { ResultsFilterAndSortDrawerComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsFilterAndSortDrawerComposable };

  
  import { ResultsDimensionsComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsDimensionsComposable };

  
  import { ResultsSortByComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsSortByComposable };

  
  import { FlooringDrawer }
    from "@thd-olt-component-react/flooring-picker";
  
  export { FlooringDrawer };

  
  import { DefaultGridComposable }
    from "@thd-olt-component-react/plp-grid";
  
  export { DefaultGridComposable };

  
  import { ResultsPaginationComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsPaginationComposable };

  
  import { SearchFeedback }
    from "@thd-olt-component-react/search-feedback";
  
  export { SearchFeedback };

  
  import { HdhomeSignup }
    from "@thd-olt-component-react/email-signup";
  
  export { HdhomeSignup };

  
  import { RetailMediaCarouselFusionComposable }
    from "@thd-olt-component-react/retail-media-pla-sponsored-placements";
  
  export { RetailMediaCarouselFusionComposable };

  
  import { PlpRvRenderPlaceholder }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { PlpRvRenderPlaceholder };

  
  import { EmtQuestionsAndAnswers }
    from "@thd-olt-component-react/emt-generated-content";
  
  export { EmtQuestionsAndAnswers };

  
  import { EmtGeneratedContent }
    from "@thd-olt-component-react/emt-generated-content";
  
  export { EmtGeneratedContent };

  
  import { BrandCategories }
    from "@thd-olt-component-react/emt-generated-content";
  
  export { BrandCategories };

  
  import { RelatedSearch }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedSearch };

  
  import { RelatedProducts }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedProducts };

  
  import { EmtLinks }
    from "@thd-olt-component-react/emt-links";
  
  export { EmtLinks };

  
  import { BrowseSearchRedirector }
    from "@thd-nucleus/app-render";
  
  export { BrowseSearchRedirector };

  
  import { TempDatasourcesHackForFusionDataModels }
    from "@thd-olt-component-react/temp-datasources-hack-for-fusion-dataModels";
  
  export { TempDatasourcesHackForFusionDataModels };








  
    
      
      
        const SlotA1 = withLayout(
          [
            
              
              BrowseSearchMetadata,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotA2 = withLayout(
          [
            
              
              TrackOrder,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotA3 = withLayout(
          [
            
              
              Breadcrumbs,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotB1 = withLayout(
          [
            
              
              SponsoredBannerComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotB2 = withLayout(
          [
            
              
              PLPResultsHeader,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotB3 = withLayout(
          [
            
              
              PlpCategoryIntroduction,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotB4 = withLayout(
          [
            
              
              HybridContentfulWidgetComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotB5 = withLayout(
          [
            
              
              ProductCategoryVisnavComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotC1 = withLayout(
          [
            
              
              PLPRecsComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotD1 = withLayout(
          [
            
              
              ResultsAppliedComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotD2 = withLayout(
          [
            
              
              ResultsFilterAndSortDrawerComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
        let RulesMiddleware_MiddlewareSlot_SlotE1 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotE1 = withStorefront(RulesMiddleware_MiddlewareSlot_SlotE1, {"render":{"name":"EPROCUREMENT"}})
          
        
      
      
        const SlotE1 = withLayout(
          [
            
              
              ResultsDimensionsComposable,
            
          ],
          
            RulesMiddleware_MiddlewareSlot_SlotE1
          
        );
      
      
    
  

  
    
      
      
        const SlotF1 = withLayout(
          [
            
              
              ResultsSortByComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG1 = withLayout(
          [
            
              
              FlooringDrawer,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG2 = withLayout(
          [
            
              
              ResultsAppliedComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotH1 = withLayout(
          [
            
              
              DefaultGridComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotH2 = withLayout(
          [
            
              
              ResultsPaginationComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
        let RulesMiddleware_MiddlewareSlot_SlotH3 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotH3 = withStorefront(RulesMiddleware_MiddlewareSlot_SlotH3, {"render":{"name":"EPROCUREMENT"}})
          
        
      
      
        const SlotH3 = withLayout(
          [
            
              
              SearchFeedback,
            
          ],
          
            RulesMiddleware_MiddlewareSlot_SlotH3
          
        );
      
      
    
  

  
    
      
        let RulesMiddleware_MiddlewareSlot_SlotH4 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotH4 = withStorefront(RulesMiddleware_MiddlewareSlot_SlotH4, {"render":{"name":"EPROCUREMENT"}})
          
        
      
      
        const SlotH4 = withLayout(
          [
            
              
              HdhomeSignup,
            
          ],
          
            RulesMiddleware_MiddlewareSlot_SlotH4
          
        );
      
      
    
  

  
    
      
      
        const SlotI1 = withLayout(
          [
            
              
              PLPRecsComposable,
            
          ],
          
        );
      
      
    
  

  
    
      
        let RulesMiddleware_MiddlewareSlot_SlotI2 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotI2 = withStorefront(RulesMiddleware_MiddlewareSlot_SlotI2, {"render":{"name":"EXCHANGE"}})
          
        
      
      
        const SlotI2 = withLayout(
          [
            
              
              RetailMediaCarouselFusionComposable,
            
          ],
          
            RulesMiddleware_MiddlewareSlot_SlotI2
          
        );
      
      
    
  

  
    
      
      
        const SlotI3 = withLayout(
          [
            
              
              PlpRvRenderPlaceholder,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotJ1 = withLayout(
          [
            
              
              EmtQuestionsAndAnswers,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotJ2 = withLayout(
          [
            
              
              EmtGeneratedContent,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotJ3 = withLayout(
          [
            
              
              EmtGeneratedContent,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotJ4 = withLayout(
          [
            
              
              BrandCategories,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotK1 = withLayout(
          [
            
              
              RelatedSearch,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotK2 = withLayout(
          [
            
              
              RelatedProducts,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotL1 = withLayout(
          [
            
              
              EmtLinks,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotL2 = withLayout(
          [
            
              
              BrowseSearchRedirector,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotL3 = withLayout(
          [
            
              
              TempDatasourcesHackForFusionDataModels,
            
          ],
          
        );
      
      
    
  



const ssr = typeof window === 'undefined';


  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  



export {
  
  
    
      SlotA1,
    
  
    
      SlotA2,
    
  
    
      SlotA3,
    
  
    
      SlotB1,
    
  
    
      SlotB2,
    
  
    
      SlotB3,
    
  
    
      SlotB4,
    
  
    
      SlotB5,
    
  
    
      SlotC1,
    
  
    
      SlotD1,
    
  
    
      SlotD2,
    
  
    
      SlotE1,
    
  
    
      SlotF1,
    
  
    
      SlotG1,
    
  
    
      SlotG2,
    
  
    
      SlotH1,
    
  
    
      SlotH2,
    
  
    
      SlotH3,
    
  
    
      SlotH4,
    
  
    
      SlotI1,
    
  
    
      SlotI2,
    
  
    
      SlotI3,
    
  
    
      SlotJ1,
    
  
    
      SlotJ2,
    
  
    
      SlotJ3,
    
  
    
      SlotJ4,
    
  
    
      SlotK1,
    
  
    
      SlotK2,
    
  
    
      SlotL1,
    
  
    
      SlotL2,
    
  
    
      SlotL3,
    
  

  
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  

};